import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../topic/redux/actions';
import StyleTwoSectionTitle from './StyleTwoSectionTitle'
import { topicFireEngineerImgs } from '../../images/topicImg'

export class StyleTwoCertificate extends Component {
  static propTypes = {
    topic: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  render() {
    let { itemsData } = this.props;
    return (
      <div className="topic-style-two-certificate" style={{background: `url(${itemsData.totalbackImg}) no-repeat`}}>
        <a name={itemsData.name}><StyleTwoSectionTitle isColorW={true} Data={itemsData} /></a>
        <div className='certificate_section_list flex_row'>
          {itemsData.list && itemsData.list.map(item => <div className='certificate_item' key={item.id}>
            <div className='certificate_header flex_row'>
              <img className='posi_back_img' src={topicFireEngineerImgs.certificate_title_bg} alt="" />
              <div className='certificate_header_title flex_row'>{item.title}</div>
            </div>
            <div className='certificate_content'>{item.content}</div>
          </div>)}
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    topic: state.topic,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StyleTwoCertificate);



// WEBPACK FOOTER //
// ./src/features/style-two/StyleTwoCertificate.js